export const notAddedMapping: { ID: number; TITLE: string } = {
    "ID": -1,
    "TITLE": "Ne pas intégrer",
}



